import React from 'react';
import { Btn } from './../../../components/includes/ui';
import { Modal } from './../../../components/includes/modal';
import { Loading } from './../../../components/includes/loading'
import { SnackbarStatic } from './../../../components/includes/snackbar';
import { Typography } from './../../../themes/default';
import { List, ListItem, ListItemText, ListItemSecondaryAction } from './../../../themes/list'
import { Radio } from './../../../themes/input'
import { localStorageSalesForce } from './../../../utilities/storage';
import { SalesforceService, ProductService } from './../../../services';

class Find extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      invalid: true,
      submit: false,
      selected: null,
      error: null,
      products: []
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.status !== prevProps.status) {
      if(this.state.products.length === 0){
        this._Find();
      }
    }
  }

  /*
  ** @Service
  ** @Description: Find available products in salesforce
  */

  _Find = () => {

    let salesforce = localStorageSalesForce();

    SalesforceService.products({
      token_type: salesforce.token_type,
      access_token: salesforce.access_token
    }).then((response) => {

      // @State
      // @Description: Set list of products
      this.setState({ products: response.products, loading: true });

    }).catch((error) => {

      // @State
      // @Description: Set list of products
      this.setState({ error: '' });

    })

  }

  /*
  ** @Service
  ** @Description: Create new product in my system
  */

  _Create = (values) => {

    ProductService.create(values).then((response) => {

      this.props.onSuccess(response.product);

    }).catch((error) => {

      this.setState({
        error: error.data.message,
        submit: false,
        selected: null,
        invalid: true
       });

    });

  }

  /*
  ** @Event
  ** @Description: Select product
  */

  handleProductSelect = (event) => {

    // @Product selected
    let product = this.state.products[event.target.value];

    // @State
    this.setState({ selected: product, invalid: false });

  }

  /*
  ** @Event
  ** @Description: Confirm product
  */

  handleContinue = () => {

    // @State
    this.setState({ submit: true });

    // @Product selected
    let product = this.state.selected;

    // @ToSend
    let values = {
      name:      product.name,
      price:     product.price,
      terms:     product.terms,
      prizes:    product.prizes,
      sums:      product.sumsCovered,
      sf_code:   product.product,
      sf_branch: product.branch,
      sf_plan:   product.plan
    }

    // @Service
    this._Create(values);

  }

  /*
  ** @Click
  ** @Description: Cancel create new product
  */

  handleCancel = () => {

    // @State
    this.setState({
      error: null,
      submit: false,
      selected: null,
      invalid: true
     });

    // @Output
    this.props.onCancel();

  }

  render(){

    const { products, invalid, selected, error, loading, submit } = this.state
    const { status } = this.props

    return(
      status && (
        <Modal status={ true }
          title={ `Productos disponibles (${ products.length })` }
          maxWidth="sm"
          actions={
             products.length > 0 && (
              <Btn color="primary" size="large" disabled={ invalid || submit } loading={ submit } onClick={ this.handleContinue } fullWidth>Continuar</Btn>
            )
          }
          handleCancel={ this.handleCancel }
        >

          { error && (
            <SnackbarStatic
              icon="info"
              variant="warning"
              message={ error }
              open={ true }
              fullWidth
              hideClose
              spacingBottom={16}
            />
          )}

          { loading ? (

            products.length > 0 ? (

              <React.Fragment>
                <Typography component="p" variant="subtitle2" gutterBottom>
                  Los siguientes productos son obtenidos desde Salesforce, podrás crear un producto de venta
                  seleccionado uno a continuación.
                </Typography>

                <List dense>
                  { products.map(( product, index ) => (
                    <ListItem key={ index } disableGutters divider={ (index + 1) === product.length ? false : true }>
                      <Radio
                        color="primary"
                        name="product"
                        aria-label={ product.product }
                        value={ index }
                        checked={ selected === product }
                        disableRipple
                        onChange={ this.handleProductSelect }
                      />
                      <ListItemText primary={ product.name } secondary={ `Código: ${ product.product } Ramo: ${ product.branch } Plan: ${ product.plan }` }/>
                      <ListItemSecondaryAction>$ { product.price }</ListItemSecondaryAction>
                    </ListItem>
                  )) }
                </List>
              </React.Fragment>

            ) : (

              <SnackbarStatic
                icon="info"
                variant="warning"
                message="Atención: no encontramos productos en Salesforce que puedas utilizar."
                open={true}
                fullWidth
                hideClose
              />

            )

          ) : (

            <Loading variant="primary"/>

          ) }

        </Modal>
      )
    )
  }

}

export default Find;
